import { openPrintWindow } from './printWindow';

const esc = (v) => String(v ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const qty = (n) => (Number(n) || 0).toLocaleString('en-IE', { maximumFractionDigits: 2 });
const day = (s) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : (s || '—');
};

const STYLE = `
  @page { size: A4; margin: 12mm; }
  body { font-family: Arial, sans-serif; color: #111; font-size: 12px; margin: 0; padding: 12px; }
  h1 { font-size: 18px; margin: 0 0 2px; }
  .sub { color: #555; margin-bottom: 14px; }
  h2 { font-size: 13px; margin: 16px 0 6px; }
  table { width: 100%; border-collapse: collapse; }
  th, td { border: 1px solid #bbb; padding: 4px 6px; vertical-align: top; }
  th { background: #eee; font-size: 10px; text-transform: uppercase; text-align: left; }
  .n { text-align: right; font-variant-numeric: tabular-nums; }
  .muted { color: #777; }
  .foot { margin-top: 16px; font-size: 10px; color: #999; }
`;

export const printPoSummary = (s) => {
  const bal = (v) => (Math.abs(v) < 0.001 ? '0' : v > 0 ? `${qty(v)} short` : `+${qty(-v)} over`);
  const lines = s.lines.map((r) => `<tr><td>${esc(r.product_name)}</td><td>${esc(r.supplier_product_code)}</td>
    <td class="n">${qty(r.ordered)}</td><td class="n">${qty(r.dispatched)}</td><td class="n">${qty(r.in_progress)}</td>
    <td class="n">${qty(r.closed_short)}</td><td class="n"><b>${bal(r.outstanding)}</b></td></tr>`).join('');
  const variance = (p) => (p.planned_units == null ? '' : `${qty(p.planned_units)} → ${qty(p.units)}${p.variances.map((v) => `<br>${esc(v.product_name)} ${v.diff > 0 ? '+' : ''}${qty(v.diff)}`).join('')}`);
  const parts = s.parts.map((p) => `<tr><td>Part ${esc(p.part_number)}</td><td>${esc(p.dispatch_number)}</td><td>${esc(p.state)}</td>
    <td>${esc(day(p.dispatch_date))}</td><td class="n">${qty(p.units)}</td><td>${variance(p)}</td>
    <td>${p.batches.map((b) => `${esc(b.product_name)}: ${esc(b.batch_code)} (${qty(b.units)})`).join('<br>') || '<span class="muted">not batched yet</span>'}</td>
    <td>${esc(p.invoice_number || p.accountsiq_invoice_id || '')}</td></tr>`).join('');
  const adj = (s.adjustments || []).map((a) => `<tr><td>${esc((a.at || '').slice(0, 16).replace('T', ' '))}</td><td>Part ${esc(a.from_part)}</td>
    <td>${esc(a.product_name)}</td><td>${esc(a.kind)} ${qty(Math.abs(a.units))}</td>
    <td>${a.to_dispatch_number ? `Part ${esc(a.to_part)} (${esc(a.to_dispatch_number)}) ${a.units > 0 ? '+' : '−'}${qty(Math.abs(a.units))}` : 'stays on PO'}</td><td>${esc(a.by)}</td></tr>`).join('');
  const html = `<!doctype html><html><head><title>PO ${esc(s.po_number)} summary</title><style>${STYLE}</style></head><body>
    <h1>PO ${esc(s.po_number || '—')} · ${esc(s.customer_name)}</h1>
    <div class="sub">${s.status === 'complete' ? 'Complete' : 'In progress'} · ${s.dispatch_count} dispatch note(s) sent · ${s.open_count} open · original order ${esc(s.original_dispatch_number)}</div>
    <h2>By product</h2>
    <table><thead><tr><th>Product</th><th>Code</th><th class="n">Ordered</th><th class="n">Dispatched</th><th class="n">In progress</th><th class="n">Closed short</th><th class="n">Over / short</th></tr></thead><tbody>${lines}</tbody></table>
    <h2>Dispatch notes</h2>
    <table><thead><tr><th>Part</th><th>Dispatch note</th><th>State</th><th>Date</th><th class="n">Units</th><th>Planned → shipped</th><th>Batches</th><th>Invoice</th></tr></thead><tbody>${parts}</tbody></table>
    ${adj ? `<h2>Over / short carried between parts</h2><table><thead><tr><th>When</th><th>From</th><th>Product</th><th>Over / short</th><th>Carried to</th><th>By</th></tr></thead><tbody>${adj}</tbody></table>` : ''}
    <div class="foot">Printed ${esc(new Date().toLocaleString('en-IE'))}</div></body></html>`;
  openPrintWindow(html);
};
